export default "__VITE_ASSET__4f7b9225__"